let audioCtx = null;

function getCtx() {
  if (typeof window === 'undefined') return null;
  if (!audioCtx) {
    const AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return null;
    audioCtx = new AC();
  }
  return audioCtx;
}

/** Brauzer ovozini ochish (birinchi bosishda) */
export function unlockAudio() {
  const ctx = getCtx();
  if (!ctx) return;
  if (ctx.state === 'suspended') {
    ctx.resume().catch(() => {});
  }
}

/**
 * Yoqimli major arpeggio chime (C–E–G) — quiz “first buzz” uchun.
 */
export function playBuzzChime() {
  const ctx = getCtx();
  if (!ctx) return;

  const start = () => {
    const now = ctx.currentTime;
    const notes = [
      { freq: 523.25, at: 0 }, // C5
      { freq: 659.25, at: 0.07 }, // E5
      { freq: 783.99, at: 0.14 }, // G5
    ];

    notes.forEach(({ freq, at }) => {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.type = 'sine';
      osc.frequency.setValueAtTime(freq, now + at);

      const t0 = now + at;
      gain.gain.setValueAtTime(0.0001, t0);
      gain.gain.exponentialRampToValueAtTime(0.28, t0 + 0.025);
      gain.gain.exponentialRampToValueAtTime(0.0001, t0 + 0.42);

      osc.connect(gain);
      gain.connect(ctx.destination);
      osc.start(t0);
      osc.stop(t0 + 0.45);
    });
  };

  if (ctx.state === 'suspended') {
    ctx.resume().then(start).catch(() => {});
  } else {
    start();
  }
}

export function vibrateBuzz(strong = true) {
  if (typeof navigator === 'undefined' || typeof navigator.vibrate !== 'function') {
    return;
  }
  try {
    // kuchli: ikki marta “ta-ta”; yengil: qisqa
    navigator.vibrate(strong ? [35, 40, 55] : [20]);
  } catch (e) {
    // ignore
  }
}

export function buzzFeedback({ sound = true, vibrate = true, strong = true } = {}) {
  unlockAudio();
  if (sound) playBuzzChime();
  if (vibrate) vibrateBuzz(strong);
}
